import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class DoubleConfirmationData {
    Action: string;
    First: ConfirmationDialogData = new ConfirmationDialogData();
    Second: ConfirmationDialogData = new ConfirmationDialogData();
}

class ConfirmationDialogData {
    Title: string = '';
    Description: string = '';
    Hint: string = '';
}

@Component({
    selector: 'hpo-double-confirmation-dialog',
    templateUrl: './double-confirmation-dialog.component.html',
    styleUrls: ['./double-confirmation-dialog.component.scss']
})
export class DoubleConfirmationDialogComponent implements OnInit {

    public dialogData: DoubleConfirmationData;
    public visibleData: ConfirmationDialogData;

    public secondConfirmation: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DoubleConfirmationDialogComponent>) { }

    public ngOnInit(): void {
        // Hardcode width to keep confirmation dialogs tidy and consistent
        this.dialogRef.updateSize('480px');

        this.dialogData = this.data ? this.data : new DoubleConfirmationData();
        this.visibleData = this.dialogData.First;
    }

    /**
     * Return true
     */
    public submit(): void {
        if (!this.secondConfirmation) {
            this.secondConfirmation = true;
            this.visibleData = this.dialogData.Second;
        }
        /*else {
            this.dialogRef.close({ first: true, second: true });
        }*/
    }

    /**
     * Return false
     */
    public submitWithOptions(second: boolean): void {
        this.dialogRef.close({ first: true, second: second });
    }

    /**
     * Return false
     */
    public cancel(): void {
        this.dialogRef.close(undefined);
    }

}
